import React from 'react';
import { useNavigate } from 'react-router-dom';

const InstagramIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const WhatsAppIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 5.98L0 24l6.2-1.63A11.96 11.96 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52ZM12 22.07c-1.86 0-3.68-.5-5.27-1.44l-.38-.22-3.68.97.98-3.58-.25-.4A9.93 9.93 0 0 1 2 12C2 6.49 6.49 2 12 2c2.67 0 5.18 1.04 7.07 2.93A9.94 9.94 0 0 1 22 12c0 5.51-4.49 10.07-10 10.07Zm5.47-7.48c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.24-.46-2.37-1.47-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.51 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.23 5.13 4.53.72.31 1.28.5 1.71.64.72.23 1.37.2 1.89.12.58-.09 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z"/>
  </svg>
);

const SOCIAL_LINKS = [
  {
    platform: 'Instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/siddha_samaj/',
    icon: InstagramIcon,
    ariaLabel: 'Siddha Samaj on Instagram',
  },
  {
    platform: 'WhatsApp',
    label: 'Channel',
    href: 'https://whatsapp.com/channel/0029VbCBfod1Hspz4pQ8vO1q',
    icon: WhatsAppIcon,
    ariaLabel: 'Siddha Samaj WhatsApp Channel',
  },
  {
    platform: 'WhatsApp',
    label: 'Community',
    href: 'https://chat.whatsapp.com/CNtoo1OHhPcB9jyNAK605u',
    icon: WhatsAppIcon,
    ariaLabel: 'Siddha Samaj WhatsApp Community',
  },
];

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="relative mt-20">
      {/* Ornate Divider Top */}
      <div className="flex items-center justify-center mb-8">
        <div className="h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent w-full max-w-3xl"></div>
        <div className="mx-4">
          <svg width="24" height="24" viewBox="0 0 24 24" className="text-primary/60">
            <path
              d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
              fill="currentColor"
              opacity="0.8"
            />
            <circle cx="12" cy="10" r="2" fill="currentColor" />
          </svg>
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent w-full max-w-3xl"></div>
      </div>

      {/* Siddha Samaj Logo */}
      <div className="flex justify-center mb-4">
        <img
          src="https://customer-assets.emergentagent.com/job_ebb063e1-3e83-418f-bb38-602ef1351305/artifacts/yspj6tyg_Union%20of%20Shiva%20and%20Parvati.png"
          alt="Siddha Samaj"
          width="60"
          height="60"
          style={{
            display: 'inline-block',
            verticalAlign: 'middle',
            borderRadius: '50%',
            border: '1.5px solid rgba(212,168,67,0.6)',
            objectFit: 'cover',
            objectPosition: 'center 30%',
            backgroundColor: '#0a0a0a',
            boxShadow: '0 0 18px rgba(212,168,67,0.25)',
          }}
          data-testid="footer-logo-img"
        />
      </div>

      {/* Attribution */}
      <div className="text-center mb-8">
        <p className="font-heading text-[11px] tracking-[0.15em] uppercase" style={{ color: '#a07830' }}>
          MyShaktiverse &mdash; an initiative of Siddha Samaj
        </p>
      </div>

      {/* Social icons row */}
      <div className="flex items-start justify-center gap-6 mb-8" data-testid="footer-social-row">
        {SOCIAL_LINKS.map((s) => (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center text-center"
            data-testid={`footer-social-${s.label.toLowerCase()}`}
            aria-label={s.ariaLabel || `${s.platform} — ${s.label}`}
          >
            <span
              className="block transition-colors"
              style={{ color: '#9a7030' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#d4a843')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#9a7030')}
            >
              {s.icon}
            </span>
            <span
              className="mt-1 font-heading uppercase"
              style={{ fontSize: '8px', letterSpacing: '1px', color: '#9a7030' }}
            >
              {s.label}
            </span>
          </a>
        ))}
      </div>

      {/* Ornate Divider Bottom */}
      <div className="flex items-center justify-center mb-8">
        <div className="h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent w-full max-w-2xl"></div>
        <div className="mx-3">
          <svg width="16" height="16" viewBox="0 0 24 24" className="text-primary/40">
            <circle cx="12" cy="12" r="3" fill="currentColor" />
          </svg>
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent w-full max-w-2xl"></div>
      </div>

      {/* Navigation Links */}
      <nav className="flex flex-wrap justify-center gap-6 mb-8 px-4">
        {['About', 'Courses', 'Guides', 'Community', 'Contact'].map((item) => (
          <button
            key={item}
            onClick={() => navigate(`/${item.toLowerCase()}`)}
            className="text-sm font-heading text-primary/70 hover:text-primary uppercase tracking-wider transition-colors"
            data-testid={`footer-${item.toLowerCase()}-link`}
          >
            {item}
          </button>
        ))}
      </nav>

      {/* Copyright */}
      <div className="text-center pb-8">
        <p className="text-[9px] tracking-wide" style={{ color: '#5c3a08' }}>
          © Siddha Samaj. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
